<template>
  <div class="main-wrapper" v-if="themes">
    <el-tabs v-model="state" @tab-click="btnNavClick">
      <el-tab-pane :label="'全部模板(' + allCount + ')'" name="All"></el-tab-pane>
      <el-tab-pane :label="'待审核模板(' + pendingCount + ')'" name="Pending"></el-tab-pane>
      <el-tab-pane :label="'已发布模板(' + publishedCount + ')'" name="Published"></el-tab-pane>
      <el-tab-pane :label="'已拒绝模板(' + rejectedCount + ')'" name="Rejected"></el-tab-pane>
    </el-tabs>

    <el-table :data="themes" width="100%">
      <el-table-column label="作者" width="150">
        <template #default="scope">
          {{ scope.row.userName }}
        </template>
      </el-table-column>
      <el-table-column label="名称" width="150">
        <template #default="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="150">
        <template #default="scope">
          {{ scope.row.updatedDate }}
        </template>
      </el-table-column>
      <el-table-column label="标签">
        <template #default="scope">
          <el-link v-for="tag in scope.row.tags" :key="tag" type="success" :underline="false" style="margin-right: 10px" @click.prevent="btnTagsClick(scope.row)">
            {{ tag }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="200">
        <template #default="scope">
          <div v-if="scope.row.state === 'Rejected'">
            <small style="color: #f56c6c">
              审核未通过：
              {{ scope.row.message }}
            </small>
          </div>
          <div v-else>
            <el-link :type="scope.row.state == 'Published' ? 'success' : 'danger'" :underline="false">
              {{ getResourceState(scope.row) }}
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="价格" width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.price == 0" type="primary">免 费</el-tag>
          <el-tag v-else type="danger">￥{{ scope.row.price }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template #default="scope">
          <div class="actions">
            <el-link type="primary" @click.prevent="btnViewClick(scope.row)">查看</el-link>
            <el-link type="primary" :href="getDownloadUrl(scope.row)">下载</el-link>
            <el-link type="primary" @click.prevent="btnStateClick(scope.row)">设置</el-link>
            <el-link type="primary" :href="getPreviewUrl(scope.row)" target="_blank">预览</el-link>
            <el-link type="danger" @click.prevent="btnDeleteClick(scope.row)">删除</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :title="theme.name" direction="rtl" size="80%" v-if="theme" v-model="isTableView">
      <table-view :theme="theme"></table-view>
    </el-drawer>

    <el-dialog title="设置模板状态" v-model="isFormState" width="40%">
      <form-state :theme="theme" @cancel="isFormState = false" @submit="updateTheme"></form-state>
    </el-dialog>

    <el-dialog title="设置模板标签" v-model="isFormTags" width="40%">
      <form-tags :theme="theme" @cancel="isFormTags = false" @submit="updateTheme"></form-tags>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/themes';
import TableView from './components/themes/TableView.vue';
import FormState from './components/themes/FormState.vue';
import FormTags from './components/themes/FormTags.vue';

interface IState {
  state: string;
  themes: ITheme[];
  allTagNames: string[];
  allCount: number;
  pendingCount: number;
  publishedCount: number;
  rejectedCount: number;
  isTableView: boolean;
  theme: ITheme;
  isFormState: boolean;
  isFormTags: boolean;
}

export default defineComponent({
  components: { TableView, FormState, FormTags },
  data() {
    return {
      state: 'All',
      themes: [],
      allTagNames: [],
      allCount: 0,
      pendingCount: 0,
      publishedCount: 0,
      rejectedCount: 0,
      isTableView: false,
      theme: {} as ITheme,
      isFormState: false,
      isFormTags: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          state: this.state,
        },
        (res) => {
          this.themes = res.themes;
          if (this.state === 'All') {
            this.allTagNames = res.allTagNames;
            this.allCount = res.allCount;
            this.pendingCount = res.pendingCount;
            this.publishedCount = res.publishedCount;
            this.rejectedCount = res.rejectedCount;
          }
        },
      );
    },

    apiDelete(theme: ITheme) {
      api.delete(
        {
          userName: theme.userName,
          name: theme.name,
        },
        (res) => {
          if (!res) return;
          this.state = 'All';
          utils.success('模板删除成功！');
          this.apiGet();
        },
      );
    },

    getResourceState(theme: ITheme) {
      return utils.getResourceState(theme.state, theme.isFeatured);
    },

    getUrl(relatedUrl: string) {
      return `https://sscms.com/themes/${relatedUrl}`;
    },

    getDownloadUrl(theme: ITheme) {
      return `https://dl.sscms.com/themes/${theme.userName}/T_${theme.name}.zip`;
    },

    btnViewClick(theme: ITheme) {
      this.isTableView = true;
      this.theme = theme;
    },

    btnNavClick() {
      this.apiGet();
    },

    getPreviewUrl(theme: ITheme) {
      return theme.previewUrl;
    },

    btnDeleteClick(theme: ITheme) {
      utils.alertDelete(
        {
          title: '删除模板',
          text: `此操作将删除模板 ${theme.name}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(theme);
        },
      );
    },

    btnStateClick(theme: ITheme) {
      this.theme = theme;
      this.isFormState = true;
    },

    btnTagsClick(theme: ITheme) {
      this.theme = theme;
      this.isFormTags = true;
    },

    updateTheme(value: ITheme) {
      const index = this.themes.findIndex((x) => x.id === value.id);
      if (index !== -1) {
        this.themes[index] = value;
      }
      this.isFormState = false;
      this.isFormTags = false;
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>

<style scoped>
.block {
  padding: 30px 0;
  text-align: center;
  border-right: 1px solid #eff2f6;
  display: inline-block;
  width: 20%;
  box-sizing: border-box;
  vertical-align: top;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>
